// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fb3774fd","732":"74f1041f"}[chunkId] + ".chunk.js";
};